import { lazy } from "react";
import { RouteObject } from "react-router-dom";

const KnowledgeBase = lazy(() => import("@/pages/agent/knowledge-base/KnowledgeBase/KnowledgeBase"));
const CategoryDetail = lazy(() => import("@/pages/agent/knowledge-base/categories/CategoryDetail/CategoryDetail"));
const ArticleDetail = lazy(() => import("@/pages/agent/knowledge-base/articles/ArticleDetail/ArticleDetail"));
const SearchDetail = lazy(() => import("@/pages/agent/knowledge-base/search/SearchDetail"));

const Error404 = lazy(() => import("@/pages/Error404"));

const knowledgeBaseRoutes: RouteObject[] = [
  {
    index: true,
    element: <KnowledgeBase />,
  },
  {
    path: "search",
    element: <SearchDetail />,
  },
  {
    path: "categories",
    children: [
      {
        index: true,
        element: <Error404 />,
      },
      {
        path: ":type",
        element: <CategoryDetail />,
      },
    ],
  },
  {
    path: "articles",
    children: [
      {
        index: true,
        element: <Error404 />,
      },
      {
        path: ":id",
        element: <ArticleDetail />,
      },
    ],
  },
];

export default knowledgeBaseRoutes;
